module.exports = __webpack_public_path__ + "static/img/uploadimg.79bc6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/uploadimg.png
// module id = We2S
// module chunks = 1